import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  taskTemplateMutationKeys,
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import { ITaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'

export const useDeleteTaskTemplateVersionWarning = (
  options?: UseMutationOptions<
    ITaskTemplateVersion,
    RequestErrorType,
    RequestTypes['deleteTaskTemplateVersionWarning']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateMutationKeys.deleteTaskTemplateVersionWarning,
    ...options,
    onSuccess: (_, variables) => {
      const queryKey = taskTemplateKeys.getTaskTemplateVersion({
        templateId: variables.templateId,
        versionId: variables.versionId,
      }).queryKey

      queryClient.invalidateQueries({ queryKey })
    },
  })
}
